import { Button, Modal } from 'antd';
import { either, isNil, isEmpty } from 'ramda';
import React from 'react';
import PreviewDocument from './PreviewDocument';

const isNilOrEmpty = either(isNil, isEmpty);

const ModalPreviewDocument = ({
  html = [],
  visible,
  hide,
  isReview,
  offerId,
  documentId,
  isLoading = false,
  classNameOrientationDocument,
  pageHeightDocument,
  hasToBeOnSameSection,
  elementsToAdd,
  isModel
}) => {
  return (
    <Modal
      closable
      centered
      open={visible}
      onCancel={hide}
      footer={hasToBeOnSameSection ? null : [
        <Button
          key="ok"
          type="primary"
          onClick={hide}
        >
          OK
        </Button>
      ]}
      width="auto"
      className="modal-preview-document !w-600px !h-[95vh] overflow-auto rounded-2xl"
      bodyStyle={{ height: '95vh', overflow: 'auto' }}
      modalRender={(modal) => (
        <div className="ant-modal-content h-full flex flex-col">
          {modal}
        </div>
      )}
    >
      {isNilOrEmpty(html) && !isLoading ? <span>Aucun document à afficher.</span> : (
        <PreviewDocument
          isModel={isModel}
          hasToBeOnSameSection={hasToBeOnSameSection}
          pagesHtml={html}
          classNameOrientationDocument={classNameOrientationDocument}
          pageHeightDocument={pageHeightDocument}
          activeKey={0}
          previewHtmlLoading={isLoading}
          elementsToAdd={elementsToAdd}
        />
      )}
    </Modal>
  );
};

export default ModalPreviewDocument;
